import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

interface SoftEmptyProps {
  icon?: LucideIcon;
  title: string;
  hint?: string;
  /** Tighter padding when nested inside an already-present section. */
  inset?: boolean;
}

/**
 * Level-2 empty — a section empty inside an otherwise-present tab. A soft, dashed,
 * paper-filled row that shows what's missing honestly and never leaves a hard gap.
 */
const SoftEmpty = ({ icon: Icon, title, hint, inset }: SoftEmptyProps) => (
  <div
    className={cn(
      "flex items-center gap-3.5 rounded-[var(--radius-md)] border border-dashed border-border bg-background",
      inset ? "px-[18px] py-4" : "px-[22px] py-5",
    )}
  >
    {Icon && (
      <div className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full border border-border bg-card">
        <Icon className="h-[18px] w-[18px] text-ink-500" strokeWidth={1.8} />
      </div>
    )}
    <div className="min-w-0">
      <div className="text-sm font-semibold text-ink-700">{title}</div>
      {hint && <div className="mt-0.5 text-[13px] text-ink-500">{hint}</div>}
    </div>
  </div>
);

export default SoftEmpty;
